<template>
  <el-cascader :props="props" size="small" style="margin-left: 0px; width:240px" @change="chooseGoodsClass"
  :disabled="isDisabled"
    :options="optionsData" v-model="classValue" >
    <template slot-scope="{ node, data }">
      <span @click="getCheckedNodes(data)">{{ data.label }} </span>
    </template>
  </el-cascader>
</template>

<script>

import { goodsclassOne, goodsclassTwo } from "@/api/commodityreference";

let id = 0;
export default {
  props:{ 
    isDisabled:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    let self = this;
    return {
      // classValue: ['1620589548142895104', '1620589548193226759', '1620589548193226760'],
      classValue: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          self.loadNode(node, resolve)
        }
      },
      // options: [{
      //   value: 'zhinan',
      //   label: '指南',
      //   children: [{
      //     value: 'shejiyuanze',
      //     label: '设计原则',
      //     leaf :false,
      //     children: [{
      //       value: 'yizhi',
      //       label: '一致',
      //     leaf :true,

      //     }, {
      //       value: 'fankui',
      //       label: '反馈',
      //     leaf :true, 
      //     } ]
      //   }, {
      //     value: 'daohang',
      //     label: '导航',
      //     leaf :false, 
      //     children: [{
      //       value: 'cexiangdaohang',
      //       label: '侧向导航',
      //     leaf :true, 
      //     }, {
      //       value: 'dingbudaohang',
      //       label: '顶部导航',
      //     leaf :true, 
      //     }]
      //   }]
      // },],

      optionsData: [
      ],
      levelOne: '',
      levelTwo: '',
      levelThree: '',
      goodsOneClassIdOptions: [],
      goodsTwoClassIdOptions: [],
      goodsThreeClassIdOptions: [],
    }
  },

  created() {
  },
  methods: {
    lazyLoad(node, resolve) {
      switch (node.level) {
        case 0:
          break;
        case 1:
          break;
        case 2:
          break;
      }
    },
    loadNode(node, resolve) { 
      const { level } = node;
      let nodes = [];
      if (level == 0) {
        goodsclassOne({})
          .then((res) => {
            if (res.code == 0) {
              if (node.children && node.children.length > 0) {
                resolve([])
              } else {
                setTimeout(() => {
                  let goodsOneClassIdOptions = res.data;
                  this.goodsOneClassIdOptions = goodsOneClassIdOptions; 
                  goodsOneClassIdOptions.map((item) => {
                    let obj = {};
                    obj.value = item.id;
                    obj.label = item.name;
                    obj.level = item.level;
                    obj.leaf = false;
                    obj.children = [];
                    nodes.push(obj)
                  })
                  console.log(nodes)
                  resolve(nodes)
                }, 100)
              }

            }
          })
          .catch((err) => {
          });
        resolve(nodes)
      }

      if (level == 1) {
        let nodesTwo = [];
        if (node.children && node.children.length > 0) {
          resolve([])
        } else {
          goodsclassTwo(node.value)
            .then((res) => {
              if (res.code == 0) {
                setTimeout(() => {
                  this.goodsTwoClassIdOptions = [];
                  let goodsTwoClassIdOptions = res.data;
                  this.goodsTwoClassIdOptions = goodsTwoClassIdOptions;
                  goodsTwoClassIdOptions.map((item) => {
                    let obj = {};
                    obj.value = item.id;
                    obj.label = item.name;
                    obj.level = item.level;
                    obj.leaf = false;
                    nodesTwo.push(obj)
                  })
                  resolve(nodesTwo)
                }, 100)
              }
            })
            .catch((err) => {
            });
          resolve(nodesTwo)
        }
      }

      if (level == 2) {
        let nodesThree = [];
        if (node.children && node.children.length > 0) {
          resolve([])
        }else {
              goodsclassTwo(node.value)
              .then((res) => {
                if (res.code == 0) {
                  nodesThree = [];
                  setTimeout(() => {
                    this.goodsThreeClassIdOptions = [];
                    let goodsThreeClassIdOptions = res.data;
                    this.goodsThreeClassIdOptions = goodsThreeClassIdOptions;
                    goodsThreeClassIdOptions.map((item) => {
                      let obj = {};
                      obj.value = item.id;
                      obj.label = item.name;
                      obj.level = item.level;
                      obj.leaf = true;
                      nodesThree.push(obj)
                    })
                    console.log(nodesThree, '---nodesThree')
                    resolve(nodesThree)
                  }, 100)
                }
              })
              .catch((err) => {
              });
            resolve(nodesThree) 
        }
     
      }

    },

    init(arr) {
      if (!arr) {
        return;
      }
      this.classValue = arr;
      // console.log(this.classValue, '--this.classValue')
      goodsclassOne({})
        .then((res) => {
          let nodes = [];
          if (res.code == 0) {
            let goodsOneClassIdOptions = res.data;
            this.goodsOneClassIdOptions = goodsOneClassIdOptions;
            goodsOneClassIdOptions.map((item) => {
              let obj = {};
              obj.value = item.id;
              obj.label = item.name;
              obj.level = item.level;
              // obj.leaf = false;
              obj.children = [];
              if (item.id == this.classValue[0]) {
                goodsclassTwo(item.id)
                  .then((res2) => {
                    if (res2.code == 0) {
                      let nodesTwo = [];
                      let goodsTwoClassIdOptions = res2.data;
                      this.goodsTwoClassIdOptions = goodsTwoClassIdOptions;
                      goodsTwoClassIdOptions.map((e) => {
                        let obj2 = {};
                        obj2.value = e.id;
                        obj2.label = e.name;
                        obj2.level = e.level;
                        obj2.leaf = false;
                        obj2.children = [];
                        nodesTwo.push(obj2); 
                        if (this.classValue[1] && e.id == this.classValue[1]) {
                          goodsclassTwo(e.id)
                            .then((res3) => {
                              if (res3.code == 0) {
                                let nodesThree = [];
                                let goodsThreeClassIdOptions = res3.data;
                                this.goodsThreeClassIdOptions = goodsThreeClassIdOptions;
                                goodsThreeClassIdOptions.map((m) => {
                                  let obj3 = {};
                                  obj3.value = m.id;
                                  obj3.label = m.name;
                                  obj3.level = m.level;
                                  obj3.leaf = true;
                                  nodesThree.push(obj3);
                                })
                                obj2.children = nodesThree;
                              }
                            })
                            .catch((err) => {
                            });
                        }

                      })
                      obj.children = nodesTwo;
                    }
                  })
                  .catch((err) => {
                  });
              }
              nodes.push(obj);
            })

            this.optionsData = nodes; 
            // console.log( this.optionsData,'---optionsData')

          }
        })
        .catch((err) => {
        });
    }, 

    getCheckedNodes(e) {
      if (e.level == 1) {
        this.levelOne = e.label;
      }
      if (e.level == 2) {
        this.levelTwo = e.label;
      }
      if (e.level == 3) {
        this.levelThree = e.label;
      }
    },
    chooseGoodsClass(e) {
      // console.log(e, 'e')
      let classLabel = '';
      this.goodsOneClassIdOptions.map((item) => {
        if (e[0] && e[0] == item.id) {
          this.levelOne = item.name
        }
      })

      this.goodsTwoClassIdOptions.map((item) => {
        if (e[1] && e[1] == item.id) {
          this.levelTwo = item.name
        }
      })
      this.goodsThreeClassIdOptions.map((item) => {
        if (e[2] && e[2] == item.id) {
          this.levelThree = item.name
        }
      })
      classLabel = this.levelOne + '/' + this.levelTwo + '/' + this.levelThree;
      let arr = [];
      arr = arr.concat(e).concat([classLabel])
      // console.log(this.props,'props---')
      this.$emit('chooseClass', arr)
    },

  }
}
</script>
